<template>
    <div class="w3-container w3-responsive">
      <!-- 加载状态 -->
      <div v-if="loading" class="w3-panel w3-green w3-display-container">
        <span class="w3-button w3-large w3-display-topright" @click="loading = false">×</span>
        <p>加载中...</p>
      </div>
  
      <!-- 错误提示 -->
      <div v-if="error" class="w3-panel w3-red">
        <p>{{ error }}</p>
      </div>
       <div class="w3-card">
        <input
          type="text"
          class="w3-input w3-border"
          v-model="username2"
          placeholder="Please enter username"
          required
        >
        <button type="button" class="w3-button w3-green w3-block" @click="refresh">
            Refresh
        </button>
      </div> 
      <!-- 数据列表 -->
      <table class="w3-table w3-striped w3-bordered w3-border w3-hoverable w3-white">
        <thead>
        <tr class="w3-green">
          <th>Start</th>
          <th>End</th>
          <th>P/L</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="item in list" :key="item.RecordId" class="w3-padding">
          <td class="w3-text-grey">{{ $filters.formatDate(item.StartTime) }}</td>
          <td class="w3-text-grey">{{ $filters.formatDate(item.EndTime)}}</td>
          <td class="w3-text-grey">{{ $filters.formatNumber(item.Profit) }}</td>
        </tr>
        <tr>
          <td colspan="3" class="w3-text-grey w3-center">Total {{ list.length }} Records</td>
        </tr>        
      </tbody>
      </table>
    </div>
  </template>
  
  <script>
 import axios from 'axios';

export default {
  data() {
    return {
      username2: '',
      list: [],
      loading: false,
      error: ''
    };
  },
  created() {
    const query = this.$route.query;

    if(query.u && query.p) {
      sessionStorage.setItem('userName', query.u);
      sessionStorage.setItem('userPass', query.p);
    }
    this.userName = sessionStorage.getItem('userName');
    this.userPass = sessionStorage.getItem('userPass');
    if(this.userName && this.userPass) {
      this.username2 = query.username2 || '';
      if(this.username2){
        this.list = [];
        this.fetchData();
      }
    } else {
      this.$router.push('/login');
    }
  },
  methods: {
    async fetchData() {
      this.loading = true;
      this.error = '';
      try {

        const response = await axios.get(`${this.$apiUrl}/getGameRecord?username=${this.userName}&t=${this.userPass}&username2=${this.username2}`);
        if(response.data.code == 200){
          this.list = response.data.result;
        }else if(response.data.code == 300) {
           this.error = response.data.result;
        }else if(response.data.code == 400){
          this.$router.push('/login?err=1');
        }else if(response.data.code == 500){
          this.error = response.data.result;
        } 
      } catch (err) {
        this.error = '获取数据失败，请稍后重试。';
        console.error(err);
      } finally {
        this.loading = false;
      }
    },
    refresh(){
      this.list = [];
      this.fetchData();
    }
  }
};
  </script>
  
  <style scoped>
  /* 可选：添加自定义样式覆盖或补充 W3.CSS */
  .w3-container {
    margin: 0px auto;
    padding: 0px;
  }
  
  .w3-ul li {
    transition: background-color 0.3s;
  }
  .w3-ul li:hover {
    background-color: #f0f0f0;
  }
  </style>